// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17-iM","col":"styles_col__31bLp"};